import React, { Fragment, useRef } from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ListCategory from "../../components/category/List";
import FormCreateCategory from "../../components/category/FormCreate";
import { updateModalContent, toggleModal } from "../../actions/modal";
import CategoryList from "../../components/category/categoryList";

const List = ({ updateModalContent, toggleModal }) => {
    const formCreateRef = useRef();

    const onAddNewCategory = () => {
        updateModalContent({
            title: "Add New Category",
            content: <FormCreateCategory ref={formCreateRef} />,
            actionButton: {
                actionText: "Save",
                actionType: "primary",
                action: () => formCreateRef.current.submitForm()
            },
            cancelText: "Cancel",
            closeAfterAction: false
        });

        toggleModal();
    };

    return (
        <Fragment>
            <div className="content-header">
                <h1>Category</h1>
                <Button variant="contained" onClick={() => onAddNewCategory()}>
                    Add New
                </Button>
            </div>
            {/* <ListCategory /> */}
            <CategoryList/>
        </Fragment>
    );
};

List.postTypes = {
    updateModalContent: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired
};

export default connect(null, {
    toggleModal,
    updateModalContent
})(List);
